class passagerInscription {
	constructor(config) {
		this.config = {
			...defaults,
			...config
		};
	}

	initialize() {}

	///
	///
	/// Ajout d'un nouveau passager
	/// Page /inscription/coordonnees/{codeCircuit}/JJ-MM-AAAA
	eventAddNewPassager() {

		let self = this;
		let dataPax = self.config.dataPax;

		//initialiser à null
		dataPax.indexPassager = null;

		if (!self.config.isTravelOnlyAdult) {
			let buttons = document.querySelectorAll('.newVoyageur button');
			buttons.forEach(function (el) {
				el.addEventListener('click', function (element) {
					commons.loader.loading();
					/// Fermeture de la modale
					modalPopup.close();

					let erreur = self._EnregistrePassagers(); // enregistrement en base de données
					if (!erreur) {
						let typePassagerSuppl = element.target.getAttribute('data-type');
						dataPax[typePassagerSuppl] = parseInt(dataPax[typePassagerSuppl]) + 1;

						self._changeNbrePassager(config, dataPax);
						self._loadInfosVoyageur();
						config.nbPax++; // update nbpax
					}
					const formulaire = new Formulaire(config.form);
					formulaire.initialize('infosCoordonneesForm');

					//const tunnel = new Inscription(config);
					const utilities = new utilitiesInscription(config);
					//tunnel._formAnimation();
					utilities.initialize();
					let listPax = document.querySelectorAll('.coordonnees__pax');
					self._setMaskNaissance(listPax, utilities);

					commons.loader.loaded();
				}, {
					once: true
				});
			});
		} else {
			commons.loader.loading();
			let erreur = self._EnregistrePassagers(); // enregistrement en base de données
			if (!erreur) {
				dataPax.nbAdultes = parseInt(dataPax.nbAdultes) + 1;
				self._changeNbrePassager(config, dataPax);
				self._loadInfosVoyageur();
				config.nbPax++; // update nbpax
			}

			//const tunnel = new Inscription(config);
			const formulaire = new Formulaire(config.form);
			const utilities = new utilitiesInscription(config);
			//tunnel._formAnimation();
			formulaire.initialize('infosCoordonneesForm');
			utilities.initialize();
			let listPax = document.querySelectorAll('.coordonnees__pax');
			self._setMaskNaissance(listPax, utilities);

			commons.loader.loaded();
		}
	}

	/// Appelé sur la page coordonnées
	/// 
	deletePax(adultOnly, callback) {
		let self = this;
		let btnDeletePax = document.querySelectorAll('[data-pax-delete]');

		btnDeletePax.forEach(function (el) {
			el.addEventListener('click', function () {
				const promise1 = new Promise((resolve, reject) => {
					commons.loader.loading();
					resolve(adultOnly);
				}).then(() => {
					switch (el.dataset.typepassager) {
					case 'A':
						self.config.dataPax.nbAdultes = self.config.dataPax.nbAdultes - 1;
						break;
					case 'E2':
						self.config.dataPax.nbAdo = self.config.dataPax.nbAdo - 1;
						break;
					case 'E1':
						self.config.dataPax.nbEnfant = self.config.dataPax.nbEnfant - 1;
						break;
					case 'B':
						self.config.dataPax.nbBebe = self.config.dataPax.nbBebe - 1;
						break;
					default:
						console.error(`Sorry, we are out of ${el.dataset.typepassager}.`);
					}

					let erreur = self._EnregistrePassagers(); // enregistrement en base de données
					if (!erreur) {
						self.config.dataPax.indexPassager = el.dataset.paxDelete;
						self._changeNbrePassager(config, self.config.dataPax);
						self._loadInfosVoyageur(config, self.config.dataPax);
					}
				}).then(() => {
					//const tunnel = new Inscription(config);
					const utilities = new utilitiesInscription(config);
					const formulaire = new Formulaire(config.form);
					//tunnel._formAnimation();
					utilities.initialize();
					formulaire.initialize('infosCoordonneesForm');
					let listPax = document.querySelectorAll('.coordonnees__pax');
					self._setMaskNaissance(listPax, utilities);

					commons.loader.loaded();
					config.nbPax--; // update nbpax
				})
			}, {
				once: true
			})
		});
	}

	_setMaskNaissance(elements, utilitaire) {
		for (var i = 0; i < elements.length; i++) {
			let inputPaxDateNaissance = document.getElementById(`Inscription_ColInfoVoyageur_${i}__DateNaissance`);
			utilitaire._maskInput(inputPaxDateNaissance);
		}
	}

	///
	/// Appelé dans Voyageur.js
	eventChangeNbrePassager() {
		let self = this;
		let blockSelectPassagers = document.getElementById(this.config.blockSelectPassagersId);
		let selectsPassagers = blockSelectPassagers.querySelectorAll('select');

		/// Pour chacun des selects nombre d'adultes, ado, enfants,
		/// à l'event change, on appel la function changeNbrePassager()
		for (var i = 0; i < selectsPassagers.length; i++) {
			selectsPassagers[i].addEventListener('change', function () {

				let dataPax = {
					nbAdultes: document.getElementById('nbreAdulte').value,
					nbAdo: "0",
					nbEnfant: "0",
					nbBebe: "0"
				}

				/// Si l'on est sur un circuit de type famille, on met à jour le bouton de validation
				if (self.config.codeTypeCircuit === 2) {
					dataPax.nbEnfant = document.getElementById('nbreEnfant').value;
					dataPax.nbAdo = document.getElementById('nbreAdo').value;
				}
				if (self.config.codeTypeCircuit === 10) {
					dataPax.nbEnfant = document.getElementById('nbreEnfant').value;
					dataPax.nbAdo = document.getElementById('nbreAdo').value;
					dataPax.nbBebe = document.getElementById('nbreBebe').value;
				}

				self._changeNbrePassager(config, dataPax);
				
			})
		}
	}

	/// @requete ajax
	/// Mise à jour du récapitulatif 
	/// lorsque le nombre de passagers change
	_changeNbrePassager(config, dataPax) {
		let self = this;
		/// On stringify les valeurs 
		for (const property in dataPax) {
			if (typeof dataPax[property] === 'number') {
				dataPax[property] = dataPax[property].toString();
			}
		}
		
		$.ajax({
			url: this.config.url.changeNbPassagers,
			async: false, ///important!appel syncrone
			type: 'POST',
			data: {
				codeProduit: this.config.codeProduit,
				dateDepart: this.config.dateDepart,
				numeroDossierCrypte: this.config.numeroDossierCrypte,
				nbAdultes: dataPax.nbAdultes,
				nbEnfant: dataPax.nbEnfant,
				nbAdo: dataPax.nbAdo,
				nbBebe: dataPax.nbBebe,
				index: dataPax.indexPassager
			},
			success: function (data) {
				//console.log(data);
				$('#recapVoyage').html(data);
				
				if (config.liberte && config.step == 1) {
						self._LoadNombreVoyageur();
					
				}
				
			},
			error: function (data) {}
		});
	}

	_LoadNombreVoyageur() {

		$.ajax({
			url: "/inscription/LoadNombreVoyageur",
			async: false, ///important!appel syncrone
			type: 'POST',
			data: {
				codeProduit: this.config.codeProduit,
				dateDepart: this.config.dateDepart
				
			},
			success: function (data) {
				$('#DivNombreVoyageurs').html(data);
				const passager = new passagerInscription(config);
				passager.eventChangeNbrePassager();
				
			},
			error: function (error) {
				console.error(error)
			}
		});	
    }

	_EnregistrePassagers() {
		let self = this;
		let error = true;

		$.ajax({
			url: "/inscription/Passagers",
			async: false, ///important!appel syncrone
			type: 'POST',
			data: $('#infosCoordonneesForm').serialize(),
			success: function (data) {
				if (data != null && data != "") {
					document.querySelector(modalPopup.items.popupModal).classList.remove('modal--nouveauVoyageur');
					modalPopup.init("", data);
				} else {
					error = false;
				}
			},
			error: function (error) {
				console.error(error)
			}
		});

		return error;
	}
	/// Mise à jour de la liste des passagers
	/// sur la page coordonnées
	_loadInfosVoyageur() {
		let self = this;

		$.ajax({
			url: "/inscription/loadPassagers",
			async: false, ///important!appel syncrone
			data: {
				codeProduit: this.config.codeProduit,
				dateDepart: this.config.dateDepart,
				numeroDossierCrypte: this.config.numeroDossierCrypte
			},
			success: function (data) {
				document.getElementById('listVoyageurs').innerHTML = data;
			},
			error: function (error) {
				console.error(error)
			},
			complete: function (jqXHR, textStatus) {
				self.deletePax();

				// On récupère le nombre de pax affiché et on détermine si ce nombre est paire ou impaire
				let nbPax = document.querySelectorAll('.coordonnees__pax').length;
				let nbPaxIsOdd = nbPax % 2 === 1;

				// On récupère le btn "ajout d'un voyageur"
				let btn = document.getElementById('addNewTraveler');

				/// Le nombre de pax affiché est impaire
				if (nbPaxIsOdd) {
					btn.style.display = 'none';
					document.getElementById('addNewTravelerClone').addEventListener('click', function () {
						tunnelApp.newPax(self.config.isTravelOnlyAdult);
					});
				} else {
					btn.style.display = null;
				}

			}
		});
	}
}